"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionsMenu = void 0;
var react_1 = require("react");
var objectUtilities_1 = require("../../../util/objectUtilities");
var ActionsMenu_style_1 = __importDefault(require("./ActionsMenu.style"));
function useActionsMenu(_a) {
    var actions = _a.actions;
    var _b = __read((0, react_1.useState)(), 2), anchorElement = _b[0], setAnchorElement = _b[1];
    var closePopover = function () { return setAnchorElement(undefined); };
    var openPopover = function (event) {
        event.preventDefault();
        event.stopPropagation();
        setAnchorElement(event.currentTarget);
    };
    var handleClick = function (event, onClick) {
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick();
        closePopover();
    };
    var processedActions = (0, objectUtilities_1.filterMap)(actions, function (_a) {
        var hidden = _a.hidden, onClick = _a.onClick, warning = _a.warning, title = _a.title, action = __rest(_a, ["hidden", "onClick", "warning", "title"]);
        if (hidden) {
            return undefined;
        }
        return __assign({ onClick: function (event) { return handleClick(event, onClick); }, hoverVariant: warning ? 'error' : 'default', title: Array.isArray(title) ? title : [title] }, action);
    });
    return {
        anchorElement: anchorElement,
        classes: (0, ActionsMenu_style_1.default)(),
        closePopover: closePopover,
        openPopover: openPopover,
        processedActions: processedActions,
    };
}
exports.useActionsMenu = useActionsMenu;
